export const AdminAttachmentController = {
    destroy(): void {},
};
